import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import moment from 'moment';
import Moment from 'moment';
import { PRESCHOOL } from 'constants/schoolTypes';
import { getFileUrl } from 'actions/files';
import { clearDocumentsFromStore, clearSectionDocumentsFromStore, getDocumentsBySectionId, getDocumentsPage } from 'actions/documents';
import { clearPostsFromStore, getPostsBySectionId, getPostsPage, setPostCollectionInfo } from 'actions/posts';
import { fetch_preschoolgoals } from 'actions/preschoolform';
import { getMentorGroups } from 'actions/sections';
import { setPageTitle, setPageActions } from 'actions/header';
import { getDescription } from 'helpers/content';
import { getParameterByName } from 'helpers/url';
import User from '_class/User';
import LoadingCards from 'components/Cards/LoadingCard';
import Date from 'components/Presentation/Date/Date';
import Documentation from 'containers/Forms/Documentation';
import Post from 'containers/Forms/Post';
import Modal from 'containers/Modals/Modal';
import DatePickerFromTo from 'containers/Forms/Partials/DatePickerFromTo';
import Block, { BlockWrapper } from 'UI/Elements/Block';
import { Icon, TooltipMenu, Button, Radio } from '@haldor/ui';
import FromNow from 'components/Presentation/Date/FromNow';

var AllPosts = /*#__PURE__*/function (_Component) {
  _inherits(AllPosts, _Component);

  var _super = _createSuper(AllPosts);

  function AllPosts(props) {
    var _this;

    _classCallCheck(this, AllPosts);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var user, isPreschool, actions, groupId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              user = new User(_this.props.currentUser);
              isPreschool = user.getActiveSchool().type == PRESCHOOL;
              actions = [];

              if ((user.isMentor() || user.isAdministrator() || user.isSchoolLeader()) && _this.props.mentorGroups.length == 0) {
                _this.props.getMentorGroups();
              }

              if (!(getParameterByName('group') != null)) {
                _context.next = 8;
                break;
              }

              groupId = parseInt(getParameterByName('group'), 10);
              _context.next = 8;
              return _this.setState({
                groupFilter: groupId
              });

            case 8:
              _context.next = 10;
              return _this.props.clearPostsFromStore();

            case 10:
              _this.fetchData(_this.state.page);

              if (_this.props.preschoolGoals.length < 1 && isPreschool) {
                _this.props.fetch_preschoolgoals();
              }

              if (!user.isStudent()) {
                actions.push({
                  type: 'button',
                  value: _this.props.translate('Create post'),
                  onClick: _this.toggleEventModal,
                  buttonType: 'primary',
                  icon: 'plus'
                });

                if (isPreschool) {
                  actions.push({
                    type: 'button',
                    value: _this.props.translate('Create documentation'),
                    onClick: _this.toggleDocumentModal,
                    buttonType: 'primary',
                    icon: 'plus'
                  });
                }

                if (user.isOperationManager()) {
                  actions.push({
                    type: 'button',
                    value: _this.props.translate('Create schoolwide announcement'),
                    onClick: _this.toggleSendAllModal,
                    buttonType: 'primary',
                    icon: 'plus'
                  });
                }
              }

              _this.props.setPageTitle(_this.props.translate('preschooldocument-posts'));

              _this.props.setPageActions(actions);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchPages", function (collections) {
      var user = new User(_this.props.currentUser);
      var _this$state = _this.state,
          statusFilter = _this$state.statusFilter,
          groupFilter = _this$state.groupFilter;
      var isPreschool = user.getActiveSchool().type == PRESCHOOL;
      var start = _this.props.userRole === "student" ? null : moment(_this.state.startDate).subtract('1', 'days').format('YYYY-MM-DD');
      var end = moment(_this.state.endDate).add('1', 'days').format('YYYY-MM-DD');

      var foundInCombined = function foundInCombined(obj) {
        var added = _this.state.combined.findIndex(function (combined) {
          return combined.id == obj.id;
        });

        return added == -1;
      };

      return new Promise(function (resolve) {
        var promises = [];
        collections.map(function (collection) {
          if (collection.items.length <= 0 && collection.page > collection.fetched) {
            if (collection.type == 'DOCUMENTATION' && !isPreschool) {
              return collection;
            }

            var filter = statusFilter;

            if (collection.type == 'DOCUMENTATION' && filter != null) {
              filter = statusFilter == 'published' ? 'DOCUMENTATION_PUBLISHED' : 'DOCUMENTATION_DRAFT';
            }

            collection.fetched = collection.page;
            var promise = null;

            if (groupFilter > 0) {
              promise = collection.fetchPage(groupFilter, collection.page, filter, start, end, _this.pageSize);
            } else {
              promise = collection.fetchPage(collection.page, filter, start, end, _this.pageSize);
            }

            promises.push(promise);
          }

          return collection;
        });
        Promise.all(promises).then(function () {
          collections.map(function (collection) {
            var posts = _this.props.posts;
            var documentations = _this.props.documentations;

            if (groupFilter > 0) {
              posts = _this.props.groupPosts;
              documentations = _this.props.groupDocuments;
            }

            switch (collection.type) {
              case "POST":
                collection.items = posts.map(function (obj) {
                  return _objectSpread(_objectSpread({}, obj), {}, {
                    type: 'POST'
                  });
                }).filter(foundInCombined);
                return collection;
                break;

              case "DOCUMENTATION":
                collection.items = documentations.map(function (obj) {
                  return _objectSpread(_objectSpread({}, obj), {}, {
                    type: 'DOCUMENTATION'
                  });
                }).filter(foundInCombined);
                return collection;
                break;
            }
          });
          resolve(collections);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "paginationSort", function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
          var sortItems, combined, collection, _loop, _ret;

          return _regeneratorRuntime.wrap(function _callee2$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  // Offset start and end date by 1 day bc <>
                  sortItems = function sortItems(a, b) {
                    return Moment(b.published).unix() - Moment(a.published).unix();
                  };

                  combined = JSON.parse(JSON.stringify(_this.state.combined));
                  collection = [].concat(_toConsumableArray(_this.collections[0].items), _toConsumableArray(_this.collections[1].items)).sort(sortItems);

                  if (!(collection.length == 0)) {
                    _context3.next = 8;
                    break;
                  }

                  _context3.next = 6;
                  return _this.fetchPages(_this.collections);

                case 6:
                  _this.collections = _context3.sent;
                  collection = [].concat(_toConsumableArray(_this.collections[0].items), _toConsumableArray(_this.collections[1].items)).sort(sortItems);

                case 8:
                  _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                    var item, collectionInfo, index;
                    return _regeneratorRuntime.wrap(function _loop$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            item = collection.shift();

                            if (!(item != null)) {
                              _context2.next = 18;
                              break;
                            }

                            combined.push(item);
                            collectionInfo = _this.collections.find(function (obj) {
                              return obj.type == item.type;
                            });

                            if (!(collectionInfo != null)) {
                              _context2.next = 16;
                              break;
                            }

                            index = collectionInfo.items.findIndex(function (obj) {
                              return obj.id == item.id && obj.type == item.type;
                            });

                            if (index > -1) {
                              collectionInfo.items.splice(index, 1);
                            }

                            if (item.type == 'POST') {
                              _this.collections[0] = collectionInfo;
                            } else {
                              _this.collections[1] = collectionInfo;
                            }

                            if (!(collectionInfo.items.length <= 0)) {
                              _context2.next = 16;
                              break;
                            }

                            //Fetch next page
                            collectionInfo.page += 1;
                            _context2.next = 12;
                            return _this.setState({
                              combined: combined
                            });

                          case 12:
                            _context2.next = 14;
                            return _this.fetchPages(_this.collections);

                          case 14:
                            _this.collections = _context2.sent;
                            collection = [].concat(_toConsumableArray(_this.collections[0].items), _toConsumableArray(_this.collections[1].items)).sort(sortItems);

                          case 16:
                            _context2.next = 19;
                            break;

                          case 18:
                            return _context2.abrupt("return", "break");

                          case 19:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _loop);
                  });

                case 9:
                  if (!(combined.length < _this.pageSize * page)) {
                    _context3.next = 16;
                    break;
                  }

                  return _context3.delegateYield(_loop(), "t0", 11);

                case 11:
                  _ret = _context3.t0;

                  if (!(_ret === "break")) {
                    _context3.next = 14;
                    break;
                  }

                  return _context3.abrupt("break", 16);

                case 14:
                  _context3.next = 9;
                  break;

                case 16:
                  _context3.next = 18;
                  return _this.setState({
                    combined: combined
                  });

                case 18:
                  resolve(1);

                case 19:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(page) {
        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.setState({
                  appending: true
                });

                _context4.next = 3;
                return _this.paginationSort(page);

              case 3:
                _this.setState({
                  appending: false
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "loadMore", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var page, newPage;
      return _regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              page = _this.state.page;

              if (!_this.state.appending) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return", false);

            case 3:
              newPage = page + 1;

              _this.setState({
                appending: true
              });

              _context5.next = 7;
              return _this.paginationSort(newPage);

            case 7:
              _this.setState({
                page: newPage,
                appending: false
              });

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "resetCollectionProgress", function () {
      _this.collections = _this.collections.map(function (collection) {
        collection.page = 1;
        collection.fetched = 0;
        collection.items = [];
        return collection;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDocumentModal", function () {
      _this.setState({
        documentModal: !_this.state.documentModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEventModal", function () {
      _this.setState({
        eventModal: !_this.state.eventModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSendAllModal", function () {
      _this.setState({
        sendAllModal: !_this.state.sendAllModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterOnGroup", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(event) {
        var groupId;
        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                groupId = parseInt(event.target.value, 10);

                _this.resetCollectionProgress();

                if (!(groupId < 1)) {
                  _context6.next = 9;
                  break;
                }

                _this.collections[0].fetchPage = _this.props.getPostsPage;
                _this.collections[1].fetchPage = _this.props.getDocumentsPage;
                _context6.next = 7;
                return _this.setState({
                  combined: [],
                  groupFilter: 0,
                  page: 1
                });

              case 7:
                _context6.next = 13;
                break;

              case 9:
                _this.collections[0].fetchPage = _this.props.getPostsBySectionId;
                _this.collections[1].fetchPage = _this.props.getDocumentsBySectionId;
                _context6.next = 13;
                return _this.setState({
                  combined: [],
                  groupFilter: groupId,
                  page: 1
                });

              case 13:
                _this.fetchData(1);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "clearGroupFilter", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(event) {
        var page;
        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                event.preventDefault();

                _this.resetCollectionProgress();

                _this.collections[0].fetchPage = _this.props.getPostsPage;
                _this.collections[1].fetchPage = _this.props.getDocumentsPage;
                page = 1;
                _context7.next = 7;
                return _this.setState({
                  combined: [],
                  groupFilter: 0,
                  page: page
                });

              case 7:
                _this.fetchData(1);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onFilterDateChange", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dates) {
        var _this$state2, startDate, endDate;

        return _regeneratorRuntime.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this$state2 = _this.state, startDate = _this$state2.startDate, endDate = _this$state2.endDate;

                if (!(dates.start.format('YYYY-MM-DD') == startDate && dates.end.format('YYYY-MM-DD') == endDate)) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return", false);

              case 3:
                _this.resetCollectionProgress();

                _context8.next = 6;
                return _this.setState({
                  combined: [],
                  startDate: dates.start.format('YYYY-MM-DD'),
                  endDate: dates.end.format('YYYY-MM-DD'),
                  page: 1
                });

              case 6:
                _context8.next = 8;
                return _this.props.clearPostsFromStore();

              case 8:
                _this.fetchData(1);

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onStatusFilterChange", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(filter) {
        return _regeneratorRuntime.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(filter == _this.state.statusFilter)) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return", false);

              case 2:
                _this.resetCollectionProgress();

                _context9.next = 5;
                return _this.setState({
                  combined: [],
                  statusFilter: filter,
                  page: 1
                });

              case 5:
                _context9.next = 7;
                return _this.props.clearPostsFromStore();

              case 7:
                _this.fetchData(1);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x6) {
        return _ref8.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var combined = _this.state.combined;

      if (combined.length > 0) {
        return /*#__PURE__*/React.createElement(BlockWrapper, {
          cols: 3
        }, combined != null ? combined.map(function (document) {
          return _this.renderDocument(document);
        }) : null);
      }

      if (_this.state.appending) {
        return null;
      }

      return /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center'
        }
      }, _this.props.translate('no-items-found'));
    });

    _defineProperty(_assertThisInitialized(_this), "headerContent", function (document) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'left'
        }
      }, document.author != null ? typeof document.author == 'string' ? document.author : "".concat(document.author.firstName != null ? document.author.firstName : '', " ").concat(document.author.lastName != null ? document.author.lastName : '') : ' '), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, document.published != null ? moment.utc(document.published).isAfter(moment()) ? /*#__PURE__*/React.createElement(FromNow, null, moment.utc(document.published).local().format()) : /*#__PURE__*/React.createElement(Date, null, moment.utc(document.published).local()) : null), document.important && document.eventDate != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'left'
        }
      }) : null, document.status == 'POST_DRAFT' || document.status == 'DOCUMENTATION_DRAFT' ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right',
          marginRight: 8
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red',
          fontSize: '0.9em'
        }
      }, _this.props.translate('Draft'))) : null, document.important && document.eventDate != null && moment() <= moment(document.eventDate) ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red',
          fontSize: '0.9em',
          marginRight: '8px'
        }
      }, _this.props.translate('important!'))) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "content", function (document) {
      if (document.type == 'POST') {
        var strippedDescription = getDescription(document.body).replace(/(<([^>]+)>)/ig, '');

        if (strippedDescription.length > 99) {
          strippedDescription = strippedDescription.slice(0, 100) + '…';
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, document.title), /*#__PURE__*/React.createElement("p", {
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          },
          dangerouslySetInnerHTML: {
            __html: strippedDescription
          }
        }));
      } else {
        if (document.description) {
          var _strippedDescription = getDescription(document.description).replace(/(<([^>]+)>)/ig, '');

          if (_strippedDescription.length > 99) {
            _strippedDescription = _strippedDescription.slice(0, 100) + '…';
          }

          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, document.title), /*#__PURE__*/React.createElement("p", {
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            },
            dangerouslySetInnerHTML: {
              __html: _strippedDescription
            }
          }));
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, document.title));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "footerContent", function (document) {
      var preschoolGoals = _this.props.preschoolGoals;

      if (document.associatedGoals && document.associatedGoals.length > 0) {
        var groups = [];

        if (preschoolGoals && preschoolGoals.length > 0) {
          preschoolGoals.map(function (goal) {
            var inDocument = document.associatedGoals.find(function (goalOb) {
              return goalOb.goalId == goal.id;
            });

            if (typeof inDocument != 'undefined') {
              var inArray = groups.findIndex(function (i) {
                return i.name == goal.group;
              });

              if (inArray > -1) {
                return groups[inArray].count++;
              } else {
                var group = {
                  'name': goal.group,
                  'color': goal.colorCode,
                  'count': 1
                };
                return groups.push(group);
              }
            }
          });
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, _this.props.translate('goals')), groups.length > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "goal-preview-container"
        }, groups.map(function (group) {
          return /*#__PURE__*/React.createElement("div", {
            key: "goal-" + group.name,
            className: "goal-preview",
            style: {
              backgroundColor: group.color
            }
          }, group.name, " (", group.count, ")");
        })) : null);
      } else {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderDocument", function (document) {
      var link = '';

      if (document.type == 'POST') {
        link = 'post/' + document.id;
      } else {
        link = 'preschooldocument/' + document.id;
      }

      var file = null;

      if (document.associatedFiles != null && document.associatedFiles.length > 0) {
        file = document.associatedFiles.find(function (file) {
          return file.type && file.type.indexOf('image') > -1;
        });
      }

      if (document.status != 'POST_PUBLISHED') {
        document.published = null;
      }

      return /*#__PURE__*/React.createElement(Block, {
        key: document.id,
        headerContent: _this.headerContent(document),
        image: file,
        content: _this.content(document),
        footerContent: _this.footerContent(document),
        link: link
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCreateButton", function () {
      var isPreschool = false;

      if (_this.props.currentUser.schools.getActiveSchool(_this.props.currentUser.userId).type == PRESCHOOL) {
        isPreschool = true;
      }

      var user = new User(_this.props.currentUser);

      if (!user.isStudent() && isPreschool) {
        return /*#__PURE__*/React.createElement("div", {
          className: "create-container",
          style: {
            display: 'inline-block'
          }
        }, /*#__PURE__*/React.createElement(TooltipMenu, {
          trigger: /*#__PURE__*/React.createElement(Button, {
            type: "secondary"
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Plus"
          }), " ", _this.props.translate('Create'))
        }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: _this.toggleDocumentModal
        }, _this.props.translate('Create documentation')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: _this.toggleEventModal
        }, _this.props.translate('Create post')), user.isOperationManager() ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: _this.toggleSendAllModal
        }, _this.props.translate('Create schoolwide announcement')) : null));
      } else {
        if (!user.isStudent()) {
          if (user.isOperationManager()) {
            return /*#__PURE__*/React.createElement("div", {
              className: "create-container",
              style: {
                display: 'inline-block'
              }
            }, /*#__PURE__*/React.createElement(TooltipMenu, {
              trigger: /*#__PURE__*/React.createElement(Button, {
                type: "secondary"
              }, /*#__PURE__*/React.createElement(Icon, {
                name: "Plus"
              }), " ", _this.props.translate('Create'))
            }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
              onClick: _this.toggleEventModal
            }, _this.props.translate('Create post')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
              onClick: _this.toggleSendAllModal
            }, _this.props.translate('Create schoolwide announcement'))));
          }

          return /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: _this.toggleEventModal
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Plus"
          }), " ", _this.props.translate('Create'));
        }

        return null;
      }
    });

    _this.state = {
      documentModal: false,
      eventModal: false,
      sendAllmodal: false,
      appending: false,
      page: 1,
      groupFilter: 0,
      statusFilter: 'published',
      startDate: moment().subtract('3', 'months').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      combined: []
    };
    _this.collections = [{
      type: "POST",
      items: [],
      fetched: 0,
      page: 1,
      fetchPage: _this.props.getPostsPage
    }, {
      type: "DOCUMENTATION",
      items: [],
      fetched: 0,
      page: 1,
      fetchPage: _this.props.getDocumentsPage
    }];
    _this.pageSize = 15;
    return _this;
  }

  _createClass(AllPosts, [{
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
          appending = _this$state3.appending,
          groupFilter = _this$state3.groupFilter;
      var isPreschool = false;
      var user = new User(this.props.currentUser);

      if (user.getActiveSchool().type == PRESCHOOL) {
        isPreschool = true;
      }

      var sections = [];

      if (user.isMentor() || user.isAdministrator() || user.isSchoolLeader() || user.isOperationManager()) {
        sections = this.props.groups.concat(this.props.mentorGroups);
      } else {
        sections = this.props.groups;
      }

      if (!(user.isStudent() || user.isSchoolLeader() || user.isAdministrator() || user.isOperationManager())) {
        sections = sections.filter(function (section) {
          return section.userRole === "OWNER";
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "preschooldocuments"
      }, !user.isStudent() && isPreschool ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.documentModal,
        onClose: this.toggleDocumentModal,
        title: this.props.translate('create-new-documentation')
      }, /*#__PURE__*/React.createElement(Documentation, {
        onModalClose: this.toggleDocumentModal
      })) : null, !user.isStudent() ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.eventModal,
        onClose: this.toggleEventModal,
        title: this.props.translate('create-new-post')
      }, /*#__PURE__*/React.createElement(Post, {
        onModalClose: this.toggleEventModal
      })) : null, !user.isStudent() ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.sendAllModal,
        onClose: this.toggleSendAllModal,
        title: this.props.translate('Create schoolwide announcement')
      }, /*#__PURE__*/React.createElement(Post, {
        selectMultipleSchools: true,
        onModalClose: this.toggleEventModal
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          margin: 0,
          padding: 0,
          border: 0,
          marginBottom: '1.5rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "section-header form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "option-container filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row select"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Group')), /*#__PURE__*/React.createElement("select", {
        value: this.state.groupFilter,
        onChange: this.filterOnGroup
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, this.props.translate('select-an-alternative')), sections != null && sections.map(function (group) {
        return /*#__PURE__*/React.createElement("option", {
          value: group.id,
          key: group.id
        }, group.title);
      }))), groupFilter > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "clear-filter-container",
        onClick: this.clearGroupFilter
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Close"
      }), " ", this.props.translate('clear-filter')) : null), !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        className: "filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
        values: {
          start: this.state.startDate,
          end: this.state.endDate
        },
        onChange: this.onFilterDateChange
      }))) : null, !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        className: "filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Status')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Radio, {
        input: {
          onChange: this.onStatusFilterChange,
          value: this.state.statusFilter
        },
        disabled: appending,
        optionValue: "published",
        label: this.props.translate('Published')
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.35rem'
        }
      }, /*#__PURE__*/React.createElement(Radio, {
        input: {
          onChange: this.onStatusFilterChange,
          value: this.state.statusFilter
        },
        disabled: appending,
        optionValue: "draft",
        label: this.props.translate('Draft')
      })))) : null), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "posts-section-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "posts-content"
      }, this.renderContent(), appending ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 3
      }) : null, this.state.combined.length % this.pageSize < 1 || this.state.combined.length == this.pageSize * this.state.page ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        style: {
          margin: '2em auto',
          display: 'block'
        },
        type: "secondary",
        onClick: this.loadMore
      }, this.props.translate('load-more'))) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })));
    }
  }]);

  return AllPosts;
}(Component);

function mapStateToProps(state) {
  return {
    user: state.user.user,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    documentations: state.CombinedEvents.documentations,
    posts: state.CombinedEvents.posts,
    preschoolGoals: state.PreschoolGoals.preschoolGoals,
    groups: state.sections.educationGroups,
    mentorGroups: state.sections.mentorGroups,
    groupPosts: state.CombinedEvents.sectionPosts,
    groupDocuments: state.CombinedEvents.sectionDocumentations
  };
}

export default connect(mapStateToProps, {
  getDocumentsPage: getDocumentsPage,
  getPostsPage: getPostsPage,
  getFileUrl: getFileUrl,
  fetch_preschoolgoals: fetch_preschoolgoals,
  getPostsBySectionId: getPostsBySectionId,
  getDocumentsBySectionId: getDocumentsBySectionId,
  clearSectionDocumentsFromStore: clearSectionDocumentsFromStore,
  clearDocumentsFromStore: clearDocumentsFromStore,
  clearPostsFromStore: clearPostsFromStore,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getMentorGroups: getMentorGroups,
  setPostCollectionInfo: setPostCollectionInfo
})(AllPosts);